import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/aspnetuser'
export const namespace = 'aspnetuser'
export const clientRoute = '/user'
export const dependencies = []
export const params = {
  include: ''
}
// export const dependencies = ['aspnetroles']
// export const params = {
//   include: 'aspnetroles'
// }
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'userName'
const subtitleColumn = ''
const infoColumns = []
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
